module.exports = __webpack_public_path__ + "img/ea.0caee917.svg";